<template>
  <div>
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="Refresh"
      @search="search"
      @selectChange="cityChange"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          :disabled="!tableData.length || disabledExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import utilsTool from "@/utils/tools/tool";
import { postMemberListExport } from "@/api/export/center";
import {
  DISABLED_STATUS,
  MEMBER_VIP_STATUS,
  PROFESSION_MAP,
} from "../../utils/enum/index";
import Filtersearch from "@/components/Filtersearch.vue";
export default {
  name: "FormFilter",
  components: { Filtersearch },
  props: {
    /**
     * 携带参数
     */
    pageParams: {
      type: Object,
      default: () => {},
    },
    // /**
    //  * 城市仓列表
    //  */
    // cityStoreList: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      disabledExport: false,
      utilsTool,
      professionList: PROFESSION_MAP, // 职业下拉
      vipStatusList: Object.values(MEMBER_VIP_STATUS), // 会员状态列
      blackStatusList: Object.values(DISABLED_STATUS), // 状态枚举
      registerDate: [], // 日期对象
      logisticsList: [], // 集配中心列表
      formData: {
        logistics_id: "",
        businessLogisticId: "",
        delivery_id: "",
        mobile: "",
        fullname: "", //会员名称
        min_register_date: "", //最小注册时间
        max_register_date: "", //最大注册时间
        min_register_day: "", //最小注册天数
        max_register_day: "", //最大注册天数
        industry: "", //行业id
        min_weight: "", //最小重量
        max_weight: "", //最大重量
        min_order_number: "", //最小订单数
        max_order_number: "", //最大订单数
        is_vip: "", //是否会员 0否 1是
        member_label_ids: [], //会员标签列表
        member_grade: "", // 用户等级 单选
        purchase_hierarchy: [], //购买能力 多选
        customer_activity: "", //客户活跃度 单选
        customer_status: [], //下单状态 多选
        lossing_customer_reason: "", //原因 单选
        register_date:[],

        shopname: "", //店铺名称
        black_status: "", //用户状态
      },
      formDataClone: {}, // 复制一份，用于初始化

      Filtersearchlist: [
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "input",
          name: "客户姓名",
          clearable: true,
          model: "fullname",
          placeholder: "请输入客户姓名",
        },
        {
          type: "input",
          name: "店铺名称",
          clearable: true,
          model: "shopname",
          placeholder: "请输入店铺名称",
        },
        {
          type: "select",
          name: "从事行业",
          clearable: true,
          model: "industry",
          placeholder: "请选择从事行业",
          label: "label",
          value: "value",
          selectoption: PROFESSION_MAP,
        },
        {
          type: "select",
          name: "客户状态",
          clearable: true,
          model: "black_status",
          placeholder: "请选择客户状态",

          label: "label",
          value: "value",
          selectoption: Object.values(DISABLED_STATUS),
        },
        {
          type: "select",
          name: "客户等级",
          clearable: true,
          model: "member_grade",
          placeholder: "请选择客户等级",
          selectoptionname: "customer_grade",
           label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户标签",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "member_label_ids",
          placeholder: "请选择客户标签",
          selectoptionname: "member_label_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "是否会员",
          clearable: true,
          model: "is_vip",
          placeholder: "请选择是否会员",
          label: "label",
          value: "value",
          selectoption: Object.values(MEMBER_VIP_STATUS),
        },
        {
          type: "numinput",
          name: "注册天数",
          clearable: true,
          minmodel: "min_register_day",
          maxmodel: "max_register_day",
          placeholdermin: "请输入",
          placeholdermax: "请输入",
        },
         {
          type: "daterange",
          name: "注册日期",
          clearable: true,
          model: "register_date",
          startmodel: "min_register_date",
          endmodel: "max_register_date",
          startplaceholder: "注册日期起",
          endplaceholder: "注册日期止",
        },
        // {
        //   type: "numinput",
        //   name: "下单总重",
        //   digit:2,
        //   clearable: true,
        //   minmodel: "min_weight",
        //   maxmodel: "max_weight",
        //   placeholdermin: "请输入",
        //   placeholdermax: "请输入",
        // },
        {
          type: "numinput",
          name: "下单件数",
          clearable: true,
          minmodel: "min_order_number",
          maxmodel: "max_order_number",
          placeholdermin: "请输入",
          placeholdermax: "请输入",
        },
        {
          type: "select",
          name: "客户购买能力",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "purchase_hierarchy",
          placeholder: "请选择客户购买能力",
          selectoptionname: "purchase_hierarchy",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户活跃度",
          clearable: true,
          model: "customer_activity",
          placeholder: "请选择客户活跃度",
          selectoptionname: "customer_activity",
           label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户下单状态",
          filterable: true,
          clearable: true,
          multiple: true,
          model: "customer_status",
          placeholder: "请选择客户下单状态",
          selectoptionname: "customer_status",
          label: "value",
          value: "key",
          selectoption: [],
        },
        //  {
        //   type: "select",
        //   name: "区域经理",
        //   filterable: true,
        //   clearable: true,
        //   model: "customer_status",
        //   placeholder: "请选择区域经理",
        //   selectoptionname: "promotion_tag_list",
        //   label: "name",
        //   value: "id",
        //   selectoption: [],
        // },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "businessLogisticId",
          placeholder: "请选择集配中心",
          selectoptionname: "business_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "selectChange",
          name: "城市仓",
          clearable: true,
          filterable: true,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          selectoptionname: "cityStoreList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "自提点",
          clearable: true,
          filterable: true,
          model: "delivery_id",
          placeholder: "请选择自提点",
          selectoptionname: "selflist",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户流失原因",
          clearable: true,
          model: "lossing_customer_reason",
          placeholder: "请选择客户流失原因",
          selectoptionname: "lossing_customer_reason",
          label: "value",
          value: "key",
          selectoption: [],
        },
      ],
      tableData: [],
      total: 0,
      memberlabelalllist: [],
    };
  },
  created() {
    this.getmemberlabelall();
    this.ajaxGetLogisticList();
    this.ajaxGetCityStoreList();
    this.ajaxGetmemberconditionlist();
  },

  methods: {
    ajaxGetmemberconditionlist() {
      this.$api.member.memberconditionlist().then((res) => {
        this.Filtersearchlist.forEach((el) => {
          if (el.type == "select" && el.selectoptionname&&res.data[el.selectoptionname]) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])
            if(el.multiple){
 el.selectoption = [
             
              ...res.data[el.selectoptionname],
            ];
            }else{
 el.selectoption = [
              { value: "全部", key: "" },
              ...res.data[el.selectoptionname],
            ];
            }
           
          }
        });
      });
    },
    /**
     * 获取集配中心列表
     */
    async ajaxGetLogisticList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "business_list"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...data];
          }
        });
      } catch (err) {
        console.log("ajax ajaxGetLogisticList err", err);
      }
    },
    /**
     * 获取城市仓列表
     */
    async ajaxGetCityStoreList() {
      // this.loadingSelfLogisticsList = true;
      const params = {
        name: "",
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.logisticsList(params);

        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "selectChange" &&
            el.selectoptionname &&
            el.selectoptionname == "cityStoreList"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...data];
          }
        });
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      } finally {
        // this.loadingSelfLogisticsList = false;
      }
    },
    getListData(val) {
      this.$api.general
        .deliveryList({
          logistics_id: val, //必须填写
          page: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res, "获取数据");
          if (res.data.data.length > 0) {
            this.Filtersearchlist.forEach((el) => {
              if (
                el.type == "select" &&
                el.selectoptionname &&
                el.selectoptionname == "selflist"
              ) {
                el.selectoption = [{ id: "", name: "全部" }, ...res.data.data];
              }
            });
          }
        });
    },
    cityChange(val) {
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname &&
          el.selectoptionname == "selflist"
        ) {
          el.selectoption = [];
        }
      });
      this.$refs.Filtersearchref.from.deliveryId = "";
      // this.formData.deliveryId = "1";
      this.getListData(val);
    },
    getmemberlabelall() {
      this.$api.member.memberlabelall().then((res) => {
        console.log(res);
      this.Filtersearchlist.forEach((el) => {
              if (
                el.type == "select" &&
                el.selectoptionname &&
                el.selectoptionname == "member_label_list"
              ) {
                el.selectoption = [ ...res.data];
              }
            });
      });
    },
    /**
     * 初始化数据
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableData();
      this.getAjaxLogisticsList();
    },
    Refresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.$parent.pageParams.page = 1;
      this.$parent.pageParams.pageSize = 10;
      this.registerDate = [];
      this.ajaxGetTableData();
    },
    search(e) {
      this.formData = e;
      this.$parent.pageParams.page = 1;
      this.ajaxGetTableData();
    },
    // /**
    //  * 重置数据
    //  */
    // onHandleRefresh() {
    //   this.formData = {
    //     ...this.formDataClone,
    //   };
    //   this.$parent.pageParams.page = 1;
    //   this.$parent.pageParams.pageSize = 10;
    //   this.registerDate = [];
    //   this.ajaxGetTableData();
    // },
    // /**
    //  * 查询表单
    //  */
    // onHandleSearch() {
    //   this.$parent.pageParams.page = 1;
    //   this.ajaxGetTableData();
    // },
    /**
     * 查询列表数据
     */
    async ajaxGetTableData() {
      this.$parent.loadingData = true;
      const params = { ...this.formData, ...this.pageParams };
      try {
        const { data } = await this.$api.general.memberList(params);
        const { total, data: list, liquidate_amount_total: amountTotal } = data;
        this.total = total;
        this.tableData = list;
        const resData = {
          total,
          tableData: list,
          amountTotal,
        };
        // 更新父级列表数据
        Object.keys(resData).forEach((_key) => {
          this.$parent[_key] = resData[_key];
        });
      } catch (err) {
        console.log("ajax general.memberList err", err);
      } finally {
        this.$parent.loadingData = false;
      }
    },
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticsList = data;
        console.log("ajax getAjaxLogisticsList", data);
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 修改了每页数据条数
     */
    onHandleSizeChange(val) {
      this.$parent.pageParams.page = 1;
      this.$parent.pageParams.pageSize = val;
      this.ajaxGetTableData();
    },
    /**
     * 修改了页码
     */
    onHandleCurrentChange(val) {
      this.$parent.pageParams.page = val;
      this.ajaxGetTableData();
    },
    /**
     * 日期发生改变
     */
    onChangeDate(data) {
      this.formData.min_register_date = data?.[0] || "";
      this.formData.max_register_date = data?.[1] || "";
    },
    /**
     * 金额发生改变
     * @param {String} first 第一个参数
     * @param {String} last 第二个参数
     * @param {Number} index 对于文案下标
     */
    onChangeAmt(first, last, index) {
      const nameMap = ["注册天数", "下单总重", "下单数量"];
      if (
        this.formData[first] &&
        this.formData[last] &&
        Number(this.formData[first]) > Number(this.formData[last])
      ) {
        this.$message.warning(
          `起始${nameMap[index]}，不得大于截止${nameMap[index]}`
        );
        this.formData[last] = "";
      }
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      /** 新导出逻辑 */
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        // 组合需要的参数
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
          user_name: username,
        };
        await postMemberListExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postMemberListExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
  },
};
</script>
